import { CURRENCY_EXPONENTS } from '@norvix/utils';

/** Exact display; never round money or guess an unsupported currency exponent. */
export function formatTransactionAmount(minor: string, currency: string): string {
  // A missing or malformed amount is shown as such; it must never take the whole page down.
  if (typeof minor !== 'string' || !/^-?\d+$/.test(minor)) return 'Unavailable';
  const exponent = CURRENCY_EXPONENTS[currency];
  const amount = BigInt(minor);
  if (exponent === undefined) return `${amount.toString()} ${currency} (minor units)`;
  const negative = amount < 0n;
  const digits = (negative ? -amount : amount).toString().padStart(exponent + 1, '0');
  const whole = exponent ? digits.slice(0, -exponent) : digits;
  const fraction = exponent ? `.${digits.slice(-exponent)}` : '';
  return `${negative ? '-' : ''}${BigInt(whole).toLocaleString('en-US')}${fraction} ${currency}`;
}
